import { Component } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { AdvancedSearchTextInputComponent } from "./modules/advanced-search-text-input.component";
import { AdvancedSearchRangeComponent } from "./modules/advanced-search-range.component";
import { AdvancedSearchListComponent } from "./modules/advanced-search-list.component";
import { AdvancedSearchColorComponent } from "./modules/advanced-search-color.component";
import { take } from "rxjs";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { AdvancedSearchMultiListComponent } from "./modules/advanced-search-multi-list.component";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { MagicAdvancedSearchFile } from "@apiserver-rest/ponder-tasks-client-base";
import { AdvancedSearchParameter, AdvancedSearchService } from "./advanced-search.service";
import { NavigationService } from "@ponder-core/navigation/navigation.service";

// Same as the one in the data client, but without "Unknown" 
enum MagicRarityType {
    Common = "Common",
    Uncommon = "Uncommon",
    Rare = "Rare",
    Mythic = "Mythic",
    Special = "Special",
    Bonus = "Bonus",
}

@Component({
    imports: [
        LoadingComponent,
        ReactiveFormsModule, 
        AdvancedSearchTextInputComponent, 
        AdvancedSearchRangeComponent,
        AdvancedSearchListComponent,
        AdvancedSearchMultiListComponent,
        AdvancedSearchColorComponent
    ],
    providers: [AdvancedSearchService],
    templateUrl: "./advanced-search.component.html"
})
export class AdvancedSearchComponent {
    public searchForm!: FormGroup;

    public isLoading: boolean = true;

    public parameterTypes = AdvancedSearchParameter;
    public searchParameters?: MagicAdvancedSearchFile;

    public cardSupertypes: string[] = [];
    public cardTypes: string[] = [];
    public cardSubtypes: string[] = [];
    public cardRarities: string[] = Object.values(MagicRarityType);

    public constructor(formBuilder: FormBuilder, private navigation: NavigationService, private httpClient: HttpClient, private advancedSearch: AdvancedSearchService) {
        this.searchForm = formBuilder.group({
           // ... 
        });
    }

    public ngOnInit(): void {
        this.httpClient.get(`${environment.ponderDataBaseUrl}/advanced-search/Magic.json`)
            .pipe(take(1))
            .subscribe({
                next: (response: Object) => {
                    this.searchParameters = response as MagicAdvancedSearchFile;
                }
            })
            .add(() => { this.isLoading = false });
    }

    public canSearch(): boolean {
        return this.advancedSearch.hasAny();
    }

    public onSubmit(): void {
        if (!this.canSearch()) {
            return;
        }

        var queryParams = this.advancedSearch.toQueryParams();

        this.navigation.goto("/search", queryParams);
    }
    
    public keys(obj: { [key: string]: string; }): string[] {
        return Object.values(obj);
    }

    public values(obj: { [key: string]: string; }): string[] {
        return Object.keys(obj);
    }
}